import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.less']
})
export class LogoutComponent {
  public constructor(private router: Router) {}

  public async goHome() {
    await this.router.navigate(['/']);
  }
}
